import { intl } from "src/configs/i18n.config";

export const getCarTitle = (brand?: string, model?: string): string => {
    return intl.formatMessage(
        { id: "carTitle" },
        { name: `${brand} ${model}` }
    );
};
